//auth.guard.ts
import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { AuthenticationService } from "../services/authentication.service";
import { SignaloidWrapperService } from "@shared/services/api-services/signaloid-wrapper.service";
import { WsManagerService } from "../../../shared/services/api-services/ws-manager.service";

@Injectable({
	providedIn: "root",
})
export class AuthGuard implements CanActivate {
	constructor(
		private router: Router,
		private authService: AuthenticationService,
		private signaloidClient: SignaloidWrapperService,
		private wsManagerService: WsManagerService,
	) {}

	async canActivate(): Promise<boolean> {
		try {
			const sUser = await this.signaloidClient.getCurrentUser();
			if (sUser) {
				const session = await this.authService.getCurrentSession().catch(() => null);
				if (session) {
					if (!session.isValid()) {
						await this.signaloidClient.refreshAccessToken();
					}

					this.wsManagerService.addAuthorizationBearer(session.getAccessToken().getJwtToken());
					if (session.getIdToken().payload["email_verified"] === false) {
						this.router.navigate(["mail-otp"]);
					}

					if (!this.wsManagerService.isConnected()) {
						this.wsManagerService.establishConnection();
					}
				}
				if (session && session.isValid()) {
					return true;
				}
			}
			return false;
		} catch (error) {
			this.router.navigate(["/login"]);
			return false;
		}
	}
}
